import back from '@components/competitions/levels/muharram/assets/images/t0/back.webp';
import save from '@components/competitions/levels/muharram/assets/images/t0/save.webp';
import {days} from '@components/competitions/levels/muharram/assets/questions';
import {DayQuizWrapper} from '@components/competitions/levels/muharram/DayQuezeWrapper';
import {DaysListCol} from '@components/competitions/levels/muharram/DaysListCol';
import UserInfoForm from '@components/competitions/levels/muharram/UserInfoForm';
import {appConfig} from '@config';
import {useCompetitionMuharramContext} from '@context/CompetitionMuharramContext';
import {CircularProgress, LinearProgress, linearProgressClasses, styled, useTheme} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import axios from 'axios';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';

type IProps = {
	state?: string
};

export default function Mission0(props: IProps) {
	const theme = useTheme();
	const {t} = useTranslation();
	const [loading, setLoading] = useState(false);
	const [showUserForm, setShowUserForm] = useState(false);
	const [pendingSubmit, setPendingSubmit] = useState(false);
	const [selectedDayId, setSelectedDayId] = useState<number | null>(null);
	const [successSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
	const [lastSubmittedDayTitle, setLastSubmittedDayTitle] = useState('');
	const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const {
		answers,
		setPhone,
		phone,
		setMission
	} = useCompetitionMuharramContext();
	
	const handleSelectDay = (dayId: number) => {
		setSelectedDayId(dayId);
	};
	
	const handleBack = () => {
		setSelectedDayId(null);
	};
	
	const submitAnswers = async () => {
		const savedUser = localStorage.getItem('muharram_user');
		if (!savedUser || selectedDayId === null) return;
		
		const user = JSON.parse(savedUser);
		const normDay = selectedDayId <= 6 ? selectedDayId + 30 : selectedDayId;
		
		const lastData = {
			competition: 5,
			day: selectedDayId,
			phone: user.phone,
			answers
		};
		
		try {
			setLoading(true);
			await axios.post(`${appConfig.competition2.url}muharram`, lastData);
			const fullTitle = days[normDay]?.title || '';
			const [mainTitle] = fullTitle.split('–');
			setLastSubmittedDayTitle(mainTitle.trim());
			setSuccessSnackbarOpen(true);
			setSelectedDayId(null);
		} catch (err: any) {
			console.error('Failed to submit answers', err);
			const serverError = err.response?.data?.message || 'ارسال پاسخ‌ها با خطا مواجه شد.';
			setErrorMessage(serverError);
			setErrorSnackbarOpen(true);
		} finally {
			setLoading(false);
		}
	};
	
	const BorderLinearProgress = styled(LinearProgress)(({theme}) => ({
		height: 5,
		borderRadius: 5,
		[`&.${linearProgressClasses.colorPrimary}`]: {
			backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800]
		}
	}));
	
	return (
		<div className="w-full h-screen chat-words-choice overflow-y-scroll">
			<Snackbar
				open={successSnackbarOpen}
				autoHideDuration={4000}
				onClose={() => setSuccessSnackbarOpen(false)}
				anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
			>
				<MuiAlert onClose={() => setSuccessSnackbarOpen(false)} severity="success" sx={{width: '100%'}}>
					<div className={'w-full'}>
						پاسخ‌های شما با موفقیت تا "<strong>{lastSubmittedDayTitle}</strong>" ثبت شد.
					</div>
				</MuiAlert>
			</Snackbar>
			<Snackbar
				open={errorSnackbarOpen}
				autoHideDuration={5000}
				onClose={() => setErrorSnackbarOpen(false)}
				anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
			>
				<MuiAlert onClose={() => setErrorSnackbarOpen(false)} severity="error" sx={{width: '100%'}}>
					{errorMessage}
				</MuiAlert>
			</Snackbar>
			<div className="w-full flex flex-col justify-center items-center mx-auto">
				{/* ✅ User Info Form takes over full screen */}
				{showUserForm ? (
					<UserInfoForm
						onDone={(userData) => {
							localStorage.setItem('muharram_user', JSON.stringify(userData));
							setPhone(userData.phone);
							setShowUserForm(false);
							if (pendingSubmit) {
								submitAnswers();
								setPendingSubmit(false);
							} else {
								setSelectedDayId(null);
							}
						}}
					/>
				) : (
					<div className={'w-11/12'}>
						{selectedDayId === null ? (
							<DaysListCol onSelectDay={handleSelectDay}/>
						) : (
							<div className="w-full pb-10">
								<DayQuizWrapper dayId={selectedDayId}/>
								<div className="flex flex-row w-8/12 justify-between mx-auto">
									{loading ? (
										<div className="w-full flex justify-center">
											<CircularProgress size={28} sx={{color: '#fff'}}/>
										</div>
									) : (
										<>
											<img
												src={save}
												alt="save"
												className="w-fit h-12 cursor-pointer"
												onClick={() => {
													const hasUserInfo = localStorage.getItem('muharram_user');
													if (hasUserInfo) {
														submitAnswers();
													} else {
														setPendingSubmit(true);
														setShowUserForm(true);
													}
												}}
											/>
											<img
												src={back}
												alt="back"
												className="w-fit h-12 cursor-pointer"
												onClick={handleBack}
											/>
										</>
									)}
								</div>
							</div>
						)}
					</div>
				)}
			</div>
		</div>
	);
}
